import ProcessFieldDynamicDisplay from '@shared/components/ProcessFieldDynamic/ProcessFieldDynamicDisplay';
import useLangText from '@shared/hooks/useLangText';
import { LayoutBuilderTypeFull, ServiceVM } from '@shared/types/process';

import { useLayoutViewContext } from '../../LayoutViewContext';

import { ShadcnSkeleton } from '@shadcn-features/suspense/ShadcnSkeleton';
import React from 'react';

export const BlockViewField = ({
    block,
    isReadOnly,
    service,
}: {
    block: LayoutBuilderTypeFull;
    isReadOnly?: boolean;
    service?: ServiceVM;
}) => {
    const getLangText = useLangText();
    const { processFieldsById } = useLayoutViewContext()!;

    if (block.type !== 'Field') return null;

    return (
        <>
            {!block.children.length && (
                <ShadcnSkeleton
                    fallbackClassName='mb-6'
                    fallbackStyle={{
                        height: block.coordinates.h + 20 + 'px',
                    }}
                >
                    <ProcessFieldDynamicDisplay
                        disabled={block.options.disabled}
                        field={processFieldsById[block.options.processFieldId]}
                        isViewHaveValue={block.options.isViewHaveValue}
                        processFieldId={block.options.processFieldId}
                        readOnly={isReadOnly || block.options.readOnly}
                        required={block.options.required}
                        service={service}
                        rules={[
                            {
                                required: block.options.required,
                                message: getLangText(
                                    block.options.requiredMessage,
                                ),
                            },
                        ]}
                    />
                </ShadcnSkeleton>
            )}
        </>
    );
};
